'use client';

const DB_NAME = 'TokenCreatorForm';
const STORE_NAME = 'image';
const KEY = 'tokenImage';

export function openDB() {
  if (typeof window === 'undefined' || !window.indexedDB) return Promise.resolve(null);
  return new Promise((resolve, reject) => {
    const req = window.indexedDB.open(DB_NAME, 1);
    req.onerror = () => reject(req.error);
    req.onsuccess = () => resolve(req.result);
    req.onupgradeneeded = (e) => {
      const db = e.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
  });
}

export function saveTokenCreatorImage(blob) {
  if (typeof window === 'undefined' || !window.indexedDB || !blob) return Promise.resolve();
  return openDB().then((db) => {
    if (!db) return;
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);
      const req = store.put(blob, KEY);
      req.onsuccess = () => resolve();
      req.onerror = () => reject(req.error);
    });
  }).catch(() => {});
}

export function loadTokenCreatorImage() {
  if (typeof window === 'undefined' || !window.indexedDB) return Promise.resolve(null);
  return openDB().then((db) => {
    if (!db) return null;
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readonly');
      const store = tx.objectStore(STORE_NAME);
      const req = store.get(KEY);
      req.onsuccess = () => resolve(req.result || null);
      req.onerror = () => reject(req.error);
    });
  }).catch(() => null);
}

export function clearTokenCreatorImage() {
  if (typeof window === 'undefined' || !window.indexedDB) return Promise.resolve();
  return openDB().then((db) => {
    if (!db) return;
    return new Promise((resolve, reject) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);
      const req = store.delete(KEY);
      req.onsuccess = () => resolve();
      req.onerror = () => reject(req.error);
    });
  }).catch(() => {});
}
